/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/


// Insert any custom theme js here...
$('#shopify-section-announcement-bar, #shopify-section-header').wrapAll('<div id="header-combo" class="sticky" />');


// $('.ajax-cart__toggle').on('click', function(e){
//     e.preventDefault();
//     console.log('clicked');
//     $('body').addClass('drawer--active');
// });

// Show/Hide Search in header 
$( document ).ready(function() {
    $('.search-open').on('click', function(){
      $('#header-combo').addClass('slide-down-anim');
      $('.search-close').show();
      $('.search-open').hide();
	 
    });    
    $('.search-close').on('click', function(){
      $('#header-combo').removeClass('slide-down-anim');
      $('.search-close').hide();
      $('.search-open').show();
    });    

    // Mobile Menu Function
        
    $('.mobile-toggle-on').on('click', function(){
        $('.primary-nav').show();
        $('body').addClass('noscroll');
    });

    $('.mobile-toggle-off').on('click', function(){
        $('.primary-nav').hide();
        $('body').removeClass('noscroll');

    });

    $('ul li.expander > a').on('click', function(e){
        e.preventDefault();
        if($(this).parent().hasClass('visible')){
            $(this).parent().find('ul').hide();
            $(this).parent().removeClass('visible');
        } else {
            $(this).parent().find('ul').show();
            $(this).parent().addClass('visible');
        }

    });

    $('.nav-link').on('click', function(e){
        e.preventDefault();
        $(this).next('.submenu-slide').animate({ left: '0' }, 200);
    });

    $('.back-link').on('click', function(e){
        e.preventDefault();
        $(this).closest('.submenu-slide').animate({
            left: '100%'
        }, 200);

    });


});

// Rich Product Swiper
var richProductSwiper = new Swiper(".richProductSwiper", {
    loop: true,
    navigation: {
      nextEl: '.richProductSwiper-button-next',
      prevEl: '.richProductSwiper-button-prev',
    }
});


// Mobile Product Swiper
var mobileProductSwiper = new Swiper(".mobileProductSwiper", {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
scrollbar: {
  el: ".swiper-scrollbar"
}
});



// Desktop Product Swiper

$('.desktopProductSwiper .gallery-thumbs .product__media:first-child').addClass('selected');

$('.desktopProductSwiper .gallery-thumbs .product__media').on('click', function(){
	var id = $(this).data('id');
	$('.desktopProductSwiper .gallery-viewer .product__media').hide();
	$('.desktopProductSwiper .gallery-viewer .product__media[data-id="'+ id +'"]').show();
	$('.desktopProductSwiper .gallery-thumbs .product__media').removeClass('selected');
	$(this).addClass('selected');

});


/* Sorting for Collection */

$( document ).ready(function() {
    if($('.collection-list-group').hasClass('variants-combined')){

     
        let isMobile = false;
        $(window).on("resize", function () {
          var isMobileDevice = false; 
          if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
              || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
                isMobileDevice = true;
          }
          var $window = $(window);
          var windowsize = $window.width();
          if( isMobileDevice || windowsize < 769){
            isMobile = true;
          } else {
            isMobile = false;
          }
          
        // Invoke the resize event immediately
        }).resize();
  
  
        let multiProductList = [];
        $('.grid-item[data-productname]').each(function( index ) {
          let thisName = $( this ).data('productname');
          let thisColor = $( this ).data('colorname');
          if(multiProductList.includes(thisName)) {
          } else {
            multiProductList.push(thisName);
          }
        });
        //console.log(multiProductList);
        for (let i = 0; i < multiProductList.length; ++i) {
          let thisName =  multiProductList[i];
          console.log(thisName);
          let theseEls = $('.grid-item[data-productname="' + thisName +'"]');
          let firstEl =  theseEls.first();
          let colorHtml = '';
          let thisSeriesPhotos = '';
          theseEls.each(function( index ) {
            let thisImageDiv = '';
            let imgStyle = '';
            var colorSettings = '';
            let colorName = $(this).data('colorname');
            let colorHex = $(this).data('colorhex');
            let colorImg = $(this).data('colorimg');
            //console.log(colorImg);
            let thisLink = $(this).find('a').attr('href');
            //console.log($(this).find('.card-image-wrapper').html());
            thisImageDiv = $(this).find('.card-image-wrapper');
            thisImageDivHTML = thisImageDiv.html();
            thisImageDivStyle = $(thisImageDivHTML).attr('style');
            //console.log(thisImageDivStyle);
            if(colorImg){
                colorSettings = 'background:url(' + colorImg + ') center';
            } 
            if(colorHex){
                colorSettings = 'background:' + colorHex;
            }
            thisSeriesPhotos = thisSeriesPhotos + '<div class="card-image" data-color="'+ colorName +'" style="' + thisImageDivStyle + '"></div>';
            colorHtml = colorHtml + '<a href="'+ thisLink +'" class="color-item" data-color="'+ colorName +'"><div class="color-block" style="'+ colorSettings +'"><span class="visually-hidden">'+ colorName +'</span></div></a>';
          });
          // create a group div
          $('.flx-wrapper').append('<div class="grid-item product-group" data-name="'+ thisName +'"></div>');
          // add the first card of the series to the group
          $('.product-group[data-name="'+ thisName +'"]').append(firstEl.html());
          // Remove the rest
          theseEls.remove();
          // Replace the contents of card-image-wrapper with the images of each in the series.
          $('.product-group[data-name="'+ thisName +'"]').find('.card-image-wrapper').html(thisSeriesPhotos);
          // Add a class that hides all but the first one. (see css)
          $('.product-group[data-name="'+ thisName +'"]').find('.card-image-wrapper').addClass('multi-photo');
          // Add the color swatches
          $('.product-group[data-name="'+ thisName +'"] .card-wrapper:first-child .color-list').append(colorHtml);
        }
        colorHtml = '';
  
        // HOVER FOR COLOR SWATCHES
        if(!isMobile ){
          $('.color-item').hover(
            function () {
              let requestColor = $(this).data('color');
              let thePhotoSet = $(this).parent().parent().parent().find('.card-image');
              let showPhoto = $(this).parent().parent().parent().find('[data-color="' + requestColor + '"]');
              thePhotoSet.hide();
              showPhoto.show();
            },
            function () {
              $('.card-image').hide();
              $('.card-image-wrapper .card-image:first-child').show();
            }
          );
        }
    }
});

var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: setInterval(function() {
    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');

    var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');

    var $slides = $('.slideshow__slide');

    var currentIndex = ($slides.index($slide)) % $slides.length;

    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');

    var $buttons = $('.slideshow__button')
      .eq(currentIndex)
      .addClass('slideshow__button--active');

  }, 10000)

};

sections.extend('slideshow', slideshowAutoExtension);